import ElementAttributeObserver from '../../obervers/element-attribute-oberver';

export default class DesktopMenu {
	start() {
		this.attachEventListeners();
	}

	attachEventListeners() {
		const $ = jQuery;
		if (!coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
			$('.menu-item-has-children').children('a:eq(0)')
				.removeAttr('aria-expanded')
				.removeAttr('aria-haspopup');
			$('.menu-item-has-children').children('a:eq(0)').get()
				.forEach((item) => {
					const menuItemObserver = new ElementAttributeObserver(item);
					menuItemObserver.onUpdate(() => {
						$(item).removeAttr('aria-expanded').removeAttr('aria-haspopup');
					});
				});
		}
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/desktop-menu.js